import { useHistory, useLocation } from 'react-router-dom';
import * as queryString from 'query-string';
import useToggleFinCalcSpc from '../react/useToggleFinCalcSpc';
import { useEffect } from 'react';
import { constants } from '../../../../common/constants/constants';

const useTriggerFcOpen = (): void => {
  const { toggleFinanceCalculatorSpc } = useToggleFinCalcSpc();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const searchParams = queryString.parse(history.location.search, { arrayFormat: 'comma' });

    if (searchParams[constants.OPEN_FC]) {
      toggleFinanceCalculatorSpc(true);
      delete searchParams[constants.OPEN_FC];
    }

    const stringifySearch = queryString.stringify(searchParams, { arrayFormat: 'comma' });

    history.replace({
      ...location,
      search: stringifySearch,
    });
  }, []);
};

export default useTriggerFcOpen;
